import React from 'react'
import ReactSVG from 'react-svg'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import plusIcon from '../../../../images/plus.svg'
import styles from './navigation-account-side.css'
import { E2E_SELECTORS } from '../../../e2e-selectors'

const MyListIcon = ({ isKid }) => {
  return (
    <div
      className={classNames(styles.myListIcon, {
        [styles.isKid]: isKid
      })}
      data-lbx-e2e={E2E_SELECTORS.MY_LIST_SIDE_NAVIGATION}
    >
      <ReactSVG
        src={plusIcon}
        className={classNames({
          [styles.svgWrapper]: isKid
        })}
      />
    </div>
  )
}

MyListIcon.propTypes = {
  isKid: PropTypes.bool
}

MyListIcon.defaultProps = {
  isKid: false
}

export default MyListIcon
